<template>
  <div>
    <el-tabs v-model="activeTab" @tab-click="handleClick">
      <el-tab-pane label="Purchasing" name="purchasing">
        <purchasing ref="purchasing" :selectedRow="selectedRow"/>
      </el-tab-pane>
      <el-tab-pane label="Cash Advances" name="cashAdvances">
        {{msg}}
      </el-tab-pane>
      <el-tab-pane label="Liquidation Summary" name="liquidationSummary">
        {{msg}}
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import Purchasing from '@/components/vendors/aT/purchasing/Purchasing.vue'

  export default {
    name: 'AdvancesTo',
    props: ['selectedRow'],
    components: {
      Purchasing,
    },
    data() {
      return {
        activeTab: 'purchasing',
        msg: 'Sorry, this feature now under development will be ready later.',
      }
    },
    methods: {
      openTab() {
        this.activeTab = 'purchasing'
        this.$refs['purchasing'].openTab()
      },
      handleClick(tab, event) {
        if (tab.name === 'purchasing'){
          this.$refs['purchasing'].openTab()
        }
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>